import React from 'react';

import { DocumentImagePreview } from '../../../../../components/forms/ImageUpload/DocumentImagePreview';
import { useImageInput } from '../hooks/useImageInput';
import { Input } from '../pages/uploadImageReducer.types';

interface UploadDocumentsTileProps {
  id: string;
  input: Input;
}

export const UploadDocumentsTile = ({ id, input }: UploadDocumentsTileProps) => {
  const {
    deleteDocument,
    handleClick,
    handleOnChange,
    isBlurred,
    isLoading,
    previewImage,
    reviewStatus,
  } = useImageInput({ input });

  return (
    <li
      key={input.label as string}
      data-testid="listitem"
    >
      <DocumentImagePreview
        id={id}
        image={{ url: input.imageUrl!, ...input }}
        isBlurred={isBlurred}
        loading={isLoading}
        onChange={handleOnChange}
        onClick={handleClick}
        onDelete={(documentId) => deleteDocument({ documentId })}
        previewImage={previewImage}
        reviewStatus={reviewStatus}
      />
    </li>
  );
};
